import './Footer.css'
import { Link } from 'react-router-dom';
import { FaClock, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <div className='container'>
        <nav className='widget opened-hours'>
          <h3><FaClock className="icon" /> Horaires d'ouverture</h3>
          <ul>
            <li><span>Lundi:</span> <p>Fermé</p></li>
            <li><span>Mardi:</span> <p>12h - 15h30</p></li>
            <li><span>Mercredi:</span> <p>12h - 15h30</p></li>
            <li><span>Jeudi:</span> <p>12h - 15h30 et Afterwork dès 18h</p></li>
            <li><span>Vendredi:</span> <p>12h - 15h30 et Afterwork dès 18h</p></li>
            <li><span>Samedi:</span> <p>12h - 15h30</p></li>
            <li><span>Dimanche:</span> <p>Fermé</p></li>
          </ul>
        </nav>

        <nav className='widget widget-contact'>
          <h3>Contact</h3>
          <ul>
            <li>
              <FaPhone className="icon" />
              <div>
                <strong>Téléphone</strong>
                <p>02 47 20 50 60</p>
              </div>
            </li>
            <li>
              <FaEnvelope className="icon" />
              <div>
                <strong>Email</strong>
                <p>toursbouillon@gmail.com</p>
              </div>
            </li>
            <li>
              <FaMapMarkerAlt className="icon" />
              <div>
                <strong>Adresse</strong>
                <p>6 rue des fusillés, Tours</p>
              </div>
            </li>
          </ul>
        </nav>

        <nav className='widget widget-pages'>
          <h3>Navigation</h3>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/menu">Menu</Link></li>
            <li><Link to="/about">À propos</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        <nav className='widget widget-legal'>
          <h3>Mentions légales</h3>
          <ul>
            <li><Link to="/mentions-legales">Mentions légales</Link></li>
            <li><Link to="/politique-confidentialite">Politique de confidentialité</Link></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
